var React = require('react');

module.exports = React.createClass({
  render: function() {
    var baseProps = {
      'width': '14px',
'height': '14px',
'viewBox': '0 0 14 14',
'version': '1.1',
'xmlns': 'http://www.w3.org/2000/svg',
'xmlnsXlink': 'http://www.w3.org/1999/xlink',
      className: 'svg-icon',
      dangerouslySetInnerHTML: {
        __html: " <!-- Generator: Sketch 45.2 (43514) - http://www.bohemiancoding.com/sketch --> <title>next-green</title> <desc>Created with Sketch.</desc> <defs></defs> <g id=\"Material-Design-Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"> <g id=\"icons/next\" fill=\"#FFF\"> <g id=\"next-green\" transform=\"translate(0.380000, 0.381053)\"> <polygon id=\"Shape\" points=\"6.61894742 0.466149555 5.5422078 1.54288918 9.8491663 5.84984769 0.466149555 5.84984769 0.466149555 7.38804716 9.8491663 7.38804716 5.5422078 11.6950057 6.61894742 12.7717453 12.7717453 6.61894742\"></polygon> </g> </g> </g> ",
      }
    };
    var props = Object.assign({}, baseProps, this.props);
    return React.createElement('svg', props);
  },
});



// WEBPACK FOOTER //
// ./src/app/assets/next-white.svg